import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

interface PrivateRouteProps {
    children: ReactElement;
}

export const PrivateRoute  = ({ children }: PrivateRouteProps) => {
    const { token } = useAuth();
    return !!token ?  children  : <Navigate to="/login" />;
};